import React from "react";
import { imageUrl } from "@/lib/api";
import { useApp } from "@/context/AppContext";

/**
 * BrandLogo — renders the owner-supplied logo if uploaded in Admin Settings.
 * If NO logo is set (fresh install), renders the official wordmark exactly as supplied:
 *   "TEZZ KHANA CATERING SERVICE"
 * We never redesign or recolor once the owner uploads.
 */
export default function BrandLogo({ compact = false, className = "" }) {
  const { settings } = useApp();
  const logoId = settings?.logo_image_id;

  if (logoId) {
    return (
      <img
        src={imageUrl(logoId)}
        alt={settings?.business_name || "TEZZ KHANA CATERING SERVICE"}
        data-testid="brand-logo-image"
        className={`h-14 w-auto sm:h-16 md:h-20 ${className}`}
      />
    );
  }

  // Wordmark fallback — official name exactly, uniquely Tezz Khana (not Zomato-like).
  return (
    <div data-testid="brand-logo-wordmark" className={`flex items-center gap-3 ${className}`}>
      <span
        aria-hidden
        className="grid h-10 w-10 place-items-center rounded-full bg-primary text-primary-foreground shadow-inner sm:h-11 sm:w-11"
      >
        <span className="tk-wordmark text-lg leading-none">TK</span>
      </span>
      {!compact && (
        <span className="flex flex-col leading-tight">
          <span className="tk-wordmark text-[15px] tracking-[0.14em] text-secondary sm:text-base">
            TEZZ KHANA
          </span>
          <span className="text-[9px] font-semibold uppercase tracking-[0.32em] text-accent">
            Catering Service
          </span>
        </span>
      )}
    </div>
  );
}
